import axios from 'axios';
import { ApiResponse, zps_ms_ea_war } from '../../zps';

export type IProduct = {
  productCode: string;
  um: string;
  description: string;
  hasComposition: boolean;
  hasSN: boolean;
  priceRef: number;
  lastSupplier: number;
  lastPrice: number;
  ceCertificate: boolean;
  cbCertificate: boolean;
  averDeliTime: number;
  devType: number;
  price: number;
  ctype: number;
};

export interface ProductsResponse extends ApiResponse {
  products: IProduct[];
  totalRows: number;
}

export const fetchProducts = (
  controller: AbortController,
  offset: number,
  limit: number,
  totalRows: boolean,
  description?: string,
  productCode?: string
): Promise<ProductsResponse> => {
  const url =
    `${zps_ms_ea_war}/product?offset=${offset}&limit=${limit}&totalRows=${totalRows}` +
    (description ? `&description=${description}` : '') +
    (productCode ? `&likeProductCode=${productCode}` : '');

  return axios
    .get<ProductsResponse>(url, { signal: controller.signal })
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to fetch products:', error);
      throw error;
    });
};

export const addProduct = (product: IProduct, controller: AbortController): Promise<ProductsResponse> => {
  return axios
    .post<ProductsResponse>(`${zps_ms_ea_war}/product`, product, { signal: controller.signal })
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to add product:', error);
      throw error;
    });
};

export const updateProduct = (product: IProduct, controller: AbortController): Promise<ProductsResponse> => {
  return axios
    .put<ProductsResponse>(`${zps_ms_ea_war}/product`, product, { signal: controller.signal })
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to update product:', error);
      throw error;
    });
};

export const deleteProduct = (productCode: string, controller: AbortController): Promise<ProductsResponse> => {
  return axios
    .delete<ProductsResponse>(`${zps_ms_ea_war}/product?productCode=${productCode}`, { signal: controller.signal })
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to delete product:', error);
      throw error;
    });
};
